import PropTypes from 'prop-types';
import { css, mediaQueries } from '@eti/styles';
import { Dialog } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import SeatMapContent from '../containers/SeatMapContentContainer';
import '@eti/assets/icons/c_flat-seat-selected.svg';
import '@eti/assets/icons/c_flat-toilet.svg';
import '@eti/assets/icons/c_flat-seat-extra-legroom.svg';
import '@eti/assets/icons/c_flat-seat-front-row.svg';
import '@eti/assets/icons/c_flat-seat-economy-comfort.svg';
import '@eti/assets/icons/c_flat-seat-standard.svg';
import '@eti/assets/icons/c_flat-seat-unavailable.svg';
import '@eti/assets/icons/exit-left.svg';
import '@eti/assets/icons/exit-right.svg';
import '@eti/assets/icons/chevron-down.svg';
import { jsx as _jsx } from "react/jsx-runtime";
const seatMapDialogStyles = css`
  background: #fff;
  border-radius: 0.1875rem;
  box-shadow: 0 0 10px rgb(0 0 0 / 20%);
  height: inherit;
  max-height: 100%;
  outline: none;
  position: absolute;

  & > div {
    height: inherit;
  }

  & > div > div {
    padding: 0;
  }

  @media ${mediaQueries.medium.up} {
    height: 90vh;
    inset: 20px;
    margin: auto;
    max-width: 48rem;
  }

  @media ${mediaQueries.large.up} {
    max-width: 1200px;
  }

  @media (min-width: 1200px) {
    width: 1200px;
  }
`;
const SeatMapDialog = _ref => {
  let {
    bounds,
    callback = () => {},
    form,
    isPostBooking,
    isShowingCloseIcon = true,
    productSpecificTexts,
    setIsSeatMapModalOpen,
    show,
    travelers = []
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(Dialog, {
    className: seatMapDialogStyles,
    closeButtonAriaLabel: t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
    "data-testid": "seatMap-dialog",
    isOpen: show,
    children: /*#__PURE__*/_jsx(SeatMapContent, {
      bounds: bounds,
      callback: callback,
      form: form,
      isPostBooking: isPostBooking,
      isShowingCloseIcon: isShowingCloseIcon,
      productSpecificTexts: productSpecificTexts,
      setIsSeatMapModalOpen: setIsSeatMapModalOpen,
      travelers: travelers
    })
  });
};
SeatMapDialog.propTypes = {
  bounds: PropTypes.arrayOf(PropTypes.any).isRequired,
  callback: PropTypes.func,
  form: PropTypes.string,
  isPostBooking: PropTypes.bool,
  isShowingCloseIcon: PropTypes.bool,
  productSpecificTexts: PropTypes.shape({
    seatMapSegmentTexts: PropTypes.arrayOf(PropTypes.shape({
      boundIndex: PropTypes.number,
      segmentIndex: PropTypes.number,
      text: PropTypes.string
    }))
  }),
  setIsSeatMapModalOpen: PropTypes.func,
  show: PropTypes.bool,
  // eslint-disable-line react/boolean-prop-naming
  travelers: PropTypes.arrayOf(PropTypes.shape({
    ageType: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string
  }))
};
export default SeatMapDialog;